import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  value: string;
  subtitle?: string;
};

export const SelectDisplay: React.FC<IProps> = ({ value, subtitle }) => {
  return (
    <Flex flexDirection={'column'}>
      <Text textStyle={'textBody'}>{value}</Text>
      {subtitle && <Text textStyle="textBody">{subtitle}</Text>}
    </Flex>
  );
};
